module.exports = __webpack_public_path__ + "img/upload-file.a703a52c.svg";